import styled from 'styled-components';
import { Box } from '@user-portal/wikr-components';

import { color } from 'theme/selectors';

export const Container = styled(Box)`
    ${({ $borderRadius }) => $borderRadius && `border-radius: ${$borderRadius}px;`};
    ${({ theme, $borderColor }) => $borderColor && `border: 1px solid  ${theme[$borderColor]};`};

    width: 100%;
    > * {
        background-color: transparent !important;
    }

    &:hover {
        background-color: ${color('surface-hovered')} !important;
        color: ${color('surface-hovered')} !important;
    }
`;
